/**
 * Sync [data-nc-cart-auth] with KwikPass (empty cart + coupon).
 * APIs: XGokwikCoreToken, getValueFromCookiesOrLocalStorage, handleKpAndShopifyLogin
 * Events: user-loggedin, update-dom, kp_user_logged_out, nc-kp-orders
 */
(function () {
  if (window.__ncKpCartAuth) return;
  window.__ncKpCartAuth = true;

  var ROOT = '[data-nc-cart-auth]';
  var MSG =
    'You are not eligible for this code. Please try using another code.';

  function hasKpSession() {
    try {
      var env = window.merchantInfo && window.merchantInfo.environment;
      var key =
        typeof XGokwikCoreToken === 'function' && env
          ? XGokwikCoreToken(env)
          : env === 'production' || env === 'pci-prod'
            ? 'KWIKSESSIONTOKEN'
            : 'SANDBOXKWIKSESSIONTOKEN';

      if (typeof getValueFromCookiesOrLocalStorage === 'function') {
        return !!getValueFromCookiesOrLocalStorage(key);
      }
      if (window.localStorage && localStorage.getItem(key)) return true;
      return document.cookie.split('; ').some(function (c) {
        return c.indexOf(key + '=') === 0 && c.length > key.length + 1;
      });
    } catch (e) {
      return false;
    }
  }

  function sync(root) {
    var loggedIn =
      root.getAttribute('data-shopify-customer') === 'true' || hasKpSession();
    var login = root.querySelector('[data-nc-cart-login]');
    var welcome = root.querySelector('[data-nc-cart-welcome]');
    if (login) login.hidden = loggedIn;
    if (welcome) welcome.hidden = !loggedIn;
  }

  function syncAll() {
    document.querySelectorAll(ROOT).forEach(sync);
  }

  function firstOrderCodes() {
    return (window.ncFirstOrderCodes || []).map(function (c) {
      return String(c).toUpperCase();
    });
  }

  function ordersCount() {
    var el = document.querySelector('[data-nc-orders]');
    if (!el) return 0;
    var n = Number(el.getAttribute('data-nc-orders'));
    return n > 0 ? n : 0;
  }

  window.ncIsFirstOrderBlocked = function (code) {
    return (
      ordersCount() > 0 &&
      firstOrderCodes().indexOf(String(code).toUpperCase()) !== -1
    );
  };

  function setCouponError(text) {
    var msg = document.querySelector('.cart-drawer__coupon-message');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.remove('success');
    msg.classList.add('error');
  }

  function clearCartDiscount(msg) {
    if (typeof routes === 'undefined' || typeof fetchConfig !== 'function')
      return Promise.resolve();
    return fetch(routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify({ discount: '', attributes: { discount_code: '' } }),
    })
      .then(function () {
        var items = document.querySelector('cart-drawer-items');
        return items && typeof items.onCartUpdate === 'function'
          ? items.onCartUpdate()
          : null;
      })
      .then(function () {
        if (msg) setCouponError(msg);
      })
      .catch(function () {})
      .finally(syncAll);
  }

  function stripIneligibleCoupons() {
    var codes = firstOrderCodes();
    if (ordersCount() < 1 || !codes.length) return;
    var hit = Array.prototype.some.call(
      document.querySelectorAll('.discounts__discount-code'),
      function (node) {
        return codes.indexOf(node.textContent.trim().toUpperCase()) !== -1;
      },
    );
    if (hit) clearCartDiscount(MSG);
  }

  function refresh() {
    syncAll();
    stripIneligibleCoupons();
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-nc-kp-login]');
    if (!btn) return;
    event.preventDefault();
    if (typeof handleKpAndShopifyLogin === 'function') {
      handleKpAndShopifyLogin();
      return;
    }
    window.location.href = btn.getAttribute('href') || '/account/login';
  });

  ['user-loggedin', 'update-dom', 'nc-kp-orders'].forEach(function (name) {
    window.addEventListener(name, refresh);
  });

  window.addEventListener('kp_user_logged_out', function () {
    syncAll();
    try {
      localStorage.removeItem('nc_kp_orders');
    } catch (e) {}
    clearCartDiscount();
  });

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  customElements.whenDefined('cart-drawer').then(function () {
    var proto = customElements.get('cart-drawer').prototype;
    if (proto.__ncKpAuthPatched) return;
    proto.__ncKpAuthPatched = true;
    var open = proto.open;
    proto.open = function () {
      if (document.querySelector(ROOT)) refresh();
      return open.apply(this, arguments);
    };
  });

  customElements.whenDefined('cart-items').then(function () {
    var proto = customElements.get('cart-items').prototype;
    if (proto.__ncKpAuthOnUpdate) return;
    proto.__ncKpAuthOnUpdate = true;
    var onCartUpdate = proto.onCartUpdate;
    proto.onCartUpdate = function () {
      return Promise.resolve(onCartUpdate.apply(this, arguments)).finally(
        refresh,
      );
    };
  });
})();
